import { use } from './Notification';

export const Notification = {
  use,
};
